module.exports = __webpack_public_path__ + "img/vertical_6_2_8011.6c727d0c.png";